export const environment = {
  production: true,
  showTemplateDefault: true, //Shows or hides the menu that comes by default with the endless template.
  showBookmark: false, //Bookmarks are a set of buttons shown on the top right of the content component, right next to the breadcrumb.
  maxLoadToFilterTablesLocally: 100, //Max amount of rows that a collection or 'Table records' must have to be ordered or filtered locally.
  firebaseConfig: {
    apiKey: "AIzaSyCHTqOgzD8AMg65ys9fqD4siRX2utaGlLE",
    authDomain: "enplace-ef036.firebaseapp.com",
    projectId: "enplace-ef036",
    storageBucket: "enplace-ef036.firebasestorage.app",
    messagingSenderId: "743951231555",
    appId: "1:743951231555:web:c542f239f0186242a7c2f6",
    measurementId: "G-WL3LBF403K",
  },
  firebaseFunctionsUrl:
    "https://us-central1-appexleader-sandboxxxxxxx.cloudfunctions.net/",
  dataBaseId: "leadwize-v2xxxx",
  defaultProfilePicture: "assets/images/user/defaultPicture.png", //Default picture to show when user doesn't have an image.
  loginRememberMeVariable: "login_remember_me", //Name of the variable to use the remember me functionality of the login form. (Only email Data).
};
